import { IDeductionDisputeRepository } from "@/core/repositories/deduction";
import { RaiseDisputeDeductionDTO } from "@/core/dto/deduction/disputeDeduction";

export class RaiseDisputeDeductionUseCase {
  constructor(private readonly disputeRepository: IDeductionDisputeRepository) {}

  async execute(params: RaiseDisputeDeductionDTO) {
    const response = await this.disputeRepository.raiseDisputeDeduction(params);

    return response;
  }
}